import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { ViewStateContext } from "@is/contexts";
import { useConfiguration } from "@is/hooks";
import { TrackingEventTypes, trackEvent } from "@is/services/EventTracking";

const useManageIFramePage = () => {
  const { t } = useTranslation(TranslationContext.Settings);
  const { updateViewState } = useContext(ViewStateContext).settings;
  const { staffDashboard } = useConfiguration();
  const [portalUrl, setPortalUrl] = useState("");

  useEffect(() => {
    if (staffDashboard) {
      setPortalUrl(staffDashboard.portalUrl);
    }
  }, [staffDashboard]);

  useEffect(() => {
    trackEvent({
      eventType: TrackingEventTypes.StaffPortalOpened,
      data: {},
    });
  }, []);

  const handleClose = useCallback(() => {
    updateViewState({ showIFramePage: false });
  }, [updateViewState]);

  return { handleClose, portalUrl, t };
};

export default useManageIFramePage;
